/**
 * 確認UI（Confirmation）が Yes を出力する際に用いる定数。
 * サーバー/クライアントの両方で同じ文字列を参照するために定義しています。
 */
export const UI_CONFIRM_YES = "Yes, confirmed.";

/**
 * 確認UI（Confirmation）が No を出力する際に用いる定数。
 * サーバー/クライアントの両方で同じ文字列を参照するために定義しています。
 */
export const UI_CONFIRM_NO = "No, denied.";
